import { UnknownAction, combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import authenticationSlice from './slicers/authenticationSlice';
import deviceSlice from './slicers/deviceSlice';
import tagSlice from './slicers/tagSlice';
import timeseriesSlice from './slicers/timeseriesSlice';
import deviceTypeSlice from './slicers/deviceTypeSlice';
import organizationSlice from './slicers/organizationSlice';
import buildingSlice from './slicers/buildingSlice';

const combinedReducer = combineReducers({
	authentication: authenticationSlice.reducer,
	organization: organizationSlice.reducer,
	building: buildingSlice.reducer,
	device: deviceSlice.reducer,
	deviceType: deviceTypeSlice.reducer,
	tag: tagSlice.reducer,
	timeseries: timeseriesSlice.reducer,
});

export type RootState = ReturnType<typeof combinedReducer>;

const rootReducer: Reducer = (state: RootState, action: UnknownAction) => {
	if (action.type === 'reset-state') {
		state = {} as RootState;
	}
	return combinedReducer(state, action);
};

const store = configureStore({
	reducer: rootReducer,
	devTools: process.env.NODE_ENV !== 'production',
	middleware(getDefaultMiddlewares) {
		if (process.env.NODE_ENV === 'production') {
			return getDefaultMiddlewares();
		} else {
			return getDefaultMiddlewares();
		}
	},
});

export type AppDispatch = typeof store.dispatch;
export default store;
